module.exports = __webpack_public_path__ + "img/pd_T4.5.1.ca5d9e1d.png";